import { render, staticRenderFns } from "./SecSafety.vue?vue&type=template&id=34b07561&scoped=true&"
import script from "./SecSafety.vue?vue&type=script&lang=js&"
export * from "./SecSafety.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety.vue?vue&type=style&index=0&id=34b07561&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b07561",
  null
  
)

export default component.exports